module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/managerecord'
      }
    }
  }, [_vm._v("Manage Record")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cebc247"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin.vue
// module id = 284
// module chunks = 1